import { Button } from '@gravity-ui/uikit';
import { useLazyDownloadSubsectionReportQuery } from 'store/api';
import styles from './styles.module.scss';
import { useSubsectionDataQuery } from 'store/api/private/charts-api/chart-api-data';
import { useEffect, useState } from 'react';
import 'chart.js/auto';
import { Bar } from 'react-chartjs-2';

interface ChartData {
	labels: string[];
	datasets: {
		label: string;
		data: number[];
		backgroundColor: string[];
		borderColor: string;
		borderWidth: number;
	}[];
}

export const SubsectionDataChart = () => {
	const [trigger, { isFetching }] = useLazyDownloadSubsectionReportQuery();

	const {
		data: subsectionData,
		isLoading,
		error,
	} = useSubsectionDataQuery(null, {
		refetchOnMountOrArgChange: true,
		refetchOnFocus: true,
		refetchOnReconnect: true,
	});

	const [chartData, setChartData] = useState<ChartData>({
		labels: [],
		datasets: [
			{
				label: 'Распределение клиентов по подразделам',
				data: [],
				backgroundColor: [],
				borderColor: 'rgba(75, 192, 192, 1)',
				borderWidth: 1,
			},
		],
	});

	useEffect(() => {
		if (subsectionData) {
			const labels: string[] = [];
			const data: any[] = [];
			const backgroundColors: any[] = [];

			subsectionData?.forEach((item, index) => {
				labels.push(item.subsectionName);
				data.push(item.totalPatients);
				backgroundColors.push(`rgba(${255 - index * 50}, ${192 - index * 20}, ${192 - index * 20}, 0.2)`);
			});

			setChartData({
				labels: labels,
				datasets: [
					{
						label: 'Распределение пациентов по подразделам',
						data: data,
						backgroundColor: backgroundColors,
						borderColor: 'rgba(75, 192, 192, 1)',
						borderWidth: 1,
					},
				],
			});
		}
	}, [subsectionData]);

	const options = {
		indexAxis: 'y' as const,
		scales: {
			x: {
				beginAtZero: true,
				title: {
					display: true,
					text: 'Количество пациентов',
					font: {
						size: 16,
					},
				},
				ticks: {
					font: {
						size: 13,
					},
				},
			},
			y: {
				title: {
					display: false,
				},
				ticks: {
					font: {
						size: 13,
					},
				},
			},
		},
		plugins: {
			legend: {
				display: false,
			},
		},
	};

	const handleDownload = async () => {
		try {
			const result = await trigger().unwrap();
			const url = window.URL.createObjectURL(result);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'Отчёт по подразделам.xlsx');
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Ошибка при скачивании файла:', error);
		}
	};
	return (
		<div className={styles.chart}>
			<h2>Данные по подразделам</h2>

			<Bar data={chartData} options={options} />

			<Button onClick={handleDownload} loading={isFetching} size="xl">
				{isFetching ? 'Скачивание...' : 'Скачать отчёт по подразделам'}
			</Button>
		</div>
	);
};
